// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1Qxmb","header":"MessagesList_header__23JPE","chat":"MessagesList_chat__3aAaL"};